<template>
 <div class="row hint-container-wrapper">
  <div class="col-md-6 hint-flex-container">
    <p><span>Your token to reset your password has expired.</span></p>
    <p><span> Please click</span> <span class="black-bold cursor-pointer " @click="goToRoute"> here</span> to reset password again</p>
  </div>
 </div>
</template>

<script>
const USER_STORE_KEY = 'userStore'

export default {
  methods: {
    goToRoute() {
      this.$router.push('/reset-password')
    }
  }
}
</script>

<style lang="sass" scoped>
.hint-container-wrapper
  margin: 5rem
  display: flex
  justify-content: center
  .hint-flex-container
    display: flex
    flex-direction: column
    align-items: center
    p:nth-child(1)
      margin-bottom: 0 !important
</style>